import {createRoute, dynamicWrapper} from '@/utils/core';

const routesConfig = (app) => ({
    path: '/monitor/index',
    title: '视频监控',
    component: dynamicWrapper(app, [], () => import('./components'))
});

export default (app) => createRoute(app, routesConfig);
